import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangEnum } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  values: number[];
  months: Record<LangEnum, string[]>;
}

export const useAverageRating = (): ChartProps => {
  const { t, currentLang } = useLang();
  const { list } = useDashboardStore();
  const data = list?.feedback_average_rating as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      return {
        series: data.values.some((item) => item > 0)
          ? [{ name: t('Средний рейтинг'), data: data.values }]
          : [],
        options: {
          chart: {
            type: 'line',
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          xaxis: {
            categories: data.months[currentLang],
          },
          yaxis: [
            {
              min: 1,
              max: 5,
              labels: {
                formatter: (value: number) => Math.round(value).toString(),
              },
            },
          ],
          colors: ['#8000FF'],
          stroke: {
            width: 3,
            curve: 'smooth',
          },
          title: {
            text: t('Средний рейтинг (от 1 до 5)'),
            align: 'left',
          },
          tooltip: {
            y: {
              formatter: (value: number) => value.toFixed(2),
            },
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t, currentLang]);

  return {
    label: 'Динамика среднего рейтинга отзывов',
    subLabel:
      'Дашборд отображает, как менялся средний рейтинг отзывов за выбранный период, что помогает оценить улучшения или спад в качестве обслуживания',
    type: 'line',
    ...chartData,
  };
};
